<template>
  <div class="location-wrap">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>

        <el-form-item v-if="funcView.site_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('locationSiteBizExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right;" :class="{ 'mr-0': !funcView.site_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item v-if="funcView.site_setGoal">
          <el-button type="primary" :disabled="!hasBasicGoal" @click="onSetTargets()">{{ funcView.site_setGoal }}</el-button>
        </el-form-item>

        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_site.qu_yu_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
       <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
         <el-radio-group style="float: right; margin-right: 8px" v-model="formSearch.isSetGoal" @change="onPageChange({ page: 1 })">
          <el-radio-button :label="item.value" v-for="(item, index) in goalTypeData" :key="index">{{ item.name }}</el-radio-button>
        </el-radio-group>

      </el-form>
    </div>
    <switch-container ref="container"  @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_site.gong_si_ming_cheng')">
          <el-input
            v-model="formSearch.orgName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_site.xiang_mu_ming_cheng')">
          <el-input
            v-model="formSearch.locationName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_site.suo_shu_bu_men')">
          <el-input
            v-model="formSearch.departmentName"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        type="checkbox"
        v-model="tableSelect"
        v-if="isInch"
        tableCode="location_site_ft"
        :data="locationList"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        @column="setColumn"
        :slots="['deviceNum', 'action']"
      >
        <template v-slot:deviceNum="scope">
          <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
          <span v-else type="text">{{ scope.row.deviceNum }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click.native="editSite(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" @click.native="delSite(scope.row)" v-if="+scope.row.deviceNum===0">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
      <custom-table
        v-else
        type="checkbox"
        v-model="tableSelect"
        tableCode="location_site"
        :data="locationList"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        @column="setColumn"
        :slots="['deviceNum', 'action']"
      >
        <template v-slot:deviceNum="scope">
          <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
          <span v-else type="text">{{ scope.row.deviceNum }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click.native="editSite(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" @click.native="delSite(scope.row)" v-if="+scope.row.deviceNum===0">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- </div> -->

    <project-set-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></project-set-dialog>
    <project-site-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></project-site-dialog>
   <project-selectDevice-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false" @success="getTableList"></project-selectDevice-dialog>
    <!-- <organ-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getProjectTree"></organ-dialog> -->
  </div>
</template>

<script>
import apis from '@/utils/apis';

import projectSiteDialog from '@/pages/dms/components/project_site_dialog.vue';
import projectSelectDeviceDialog from './project_selectDevice_dialog.vue';
import projectSetDialog from './location_set_dialog.vue';

export default {
  name: 'project',
  components: {
    projectSiteDialog,
    projectSelectDeviceDialog,
    projectSetDialog
  },
  computed: {
    goalTypeData() {
      return [
        {
          value: '',
          name: this.$t('Common.com_all'),
        },
        {
          value: 0,
          name: this.$t('dms_site.wu_mu_biao'),
        },
        {
          value: 1,
          name: this.$t('dms_site.you_mu_biao'),
        },
      ];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    // 使用 computed 判断是否存在 isBasicGoal 为 0 的项
    hasBasicGoal() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '0');
    }
  },
  data() {
    return {
      tableSelect: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.locationId;
      },
      appKey: '',
      locationList: [],
      siteList: [],
      row: {},
      projectData: {},
      infoDataList: [],
      dialogVisible: false,
      dialogModel: {},
      // dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      dialogVisible4: false,
      dialogModel4: {},

      organUserList: [],
      totalRows: 0,
      childrenCount: 0,
      totalCount: 0,
      isLoading: false,

      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        isSetGoal: '',
        orgName: '', // 公司名称
        locationName: '', // 项目名称
        departmentName: '', // 所属部门

      },
      link: null,

    };
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
  },
  methods: {
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    showMoreSite: function (row) {
      // row.showMoreSiteAction = true;
      this.$set(row, 'showMoreSiteAction', true);
      return '';
    },
    getTableList: function () {
      this.$getJSON(apis.locationSiteBizPage, this.formSearch).then((res) => {
        const locationList = res.data.list || [];
        locationList.forEach((item) => {
          item.siteList = [];
        });
        this.locationList = locationList;
        this.totalRows = res.data.total;
      });
    },
    // 获取info详情列表
    getInfoDataList: function () {
      let api = '';
      let params = '';
      if (`${this.projectData.type}` === '1') {
        api = apis.locationInfo;
        params = {
          locationId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else if (`${this.projectData.type}` === '2') {
        api = apis.locationFloorInfo;
        params = {
          floorId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else if (`${this.projectData.type}` === '3') {
        api = apis.locationSiteInfo;
        params = {
          siteId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else {
        // tree无数据时显示组织名称  创建组织
        this.infoDataList = [
          {
            orgName: this.userInfo.rootOrgName,
          },
        ];
      }
    },

    // 添加项目
    addProject: function () {
      const title = this.$t('dms_site.tian_jia_xiang_mu');
      this.dialogModel.type = 'add';
      this.dialogModel.title = title;
      this.dialogModel.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
      };
      this.dialogVisible = true;
    },

    addSite: function (data) {
      const title = this.$t('dms_site.tian_jia_qu_yu');
      this.dialogModel2.type = 'add';
      this.dialogModel2.title = title;
      this.dialogModel2.data = data;
      this.dialogVisible2 = true;
    },

    editProject(data) {
      const title = this.$t('dms_site.bian_ji_xiang_mu');
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogModel.id = data.locationId;
      this.dialogModel.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
        ...data,
      };
      this.dialogVisible = true;
    },
    editFloor(data) {
      const title = this.$t('dms_site.bjqybq');
      this.dialogModel3.type = 'edit';
      this.dialogModel3.title = title;
      this.dialogModel3.data = data;
      this.dialogVisible3 = true;
    },
    editSite(data) {
      const title = this.$t('dms_site.bian_ji_qu_yu');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.title = title;
      this.dialogModel2.data = data;
      this.dialogVisible2 = true;
    },
    delProject: function (data) {
      const title = this.$t('dms_site.nqdysccxmm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationDelete}/${data.locationId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    delFloor: function (data) {
      const title = this.$t('dms_site.nqdysccqybqm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationFloorDelete}/${data.id}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    delSite: function (row) {
      const title = this.$t('dms_site.nqdysccqym');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationSiteDelete}/${row.siteId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 按推荐更新目标
    onSetTargets: function () {
      const title = this.$t('dms_site.she_zhi_mu_biao_zhi');
      this.dialogModel.title = title;
      this.dialogModel.data = this.tableSelect;
      this.dialogVisible = true;
    },
    // 关联用户弹窗
    bindDevice: function () {
      const title = this.$t('dms_site.bang_ding_she_bei');
      this.dialogModel4.title = title;
      this.dialogModel4.data = this.projectData;
      this.dialogVisible4 = true;
    },
    // 获取部门用户列表
    getDeviceList: function () {
      this.formSearch.locationId = '';
      this.formSearch.floorId = '';
      this.formSearch.siteId = '';
      if (`${this.projectData.type}` === '1') {
        this.formSearch.locationId = this.projectData.id;
      } else if (`${this.projectData.type}` === '2') {
        this.formSearch.floorId = this.projectData.id;
      } else if (`${this.projectData.type}` === '3') {
        this.formSearch.siteId = this.projectData.id;
      }

      this.isLoading = true;
      this.$getJSON(apis.locationDevicePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.organUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 展开
    exChange: function (row) {
      this.row = row;
      row.siteList = [];
      this.getSiteList(row, row.locationId);
    },
    // 获取零件变更图片
    getSiteList: function (row, locationId) {
      if (locationId) {
        this.$getJSON(apis.locationSiteAllList, {
          locationId: locationId,
        }).then((res) => {
          row.siteList = res.data || [];
          this.$set(row, 'siteList', res.data);
        });
      }

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    onDevice: function (row) {
      const siteName = row.siteName ? `/${row.siteName}` : '';
      const title = this.$t('dms_site.oooshe_bei', [this.$t('Common.com_detail'),this.row.locationName || row.locationName,siteName]);
      // this.dialogModel4.isOwner = row.isOwner;
      this.dialogModel4.title = title;
      this.dialogModel4.locationId = row.locationId;
      this.dialogModel4.locationName = this.row.locationName || row.locationName;
      this.dialogModel4.siteId = row.siteId;
      this.dialogModel4.data = row;
      this.dialogVisible4 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.location-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
}
</style>
